import { ContractStatusEnum } from "@/entities/subscription/subscription.types"
import { z } from "zod"
import {
  BillingInfoSchema,
  CardInfoSchema,
  ContractInfoSchema,
  CustomPlanInfoSchema,
  DecodedAccessTokenSchema,
  GeolocationSchema,
  SignupReqSchema,
  SubscriptionInfoSchema,
  UserFormSchema,
  UserInfoSchema,
  UserUsageSchema,
} from "./account.schema"

export enum SubscriptionAccountTypeEnum {
  Contract = "contract",
  Subscription = "subscription",
  BillingInfo = "billing_info",
}

export enum UserStatusEnum {
  VerificationRequired = "VerificationRequired",
  Verified = "Verified",
}

export enum AccountRoleEnum {
  Super = "super",
  LeadPm = "lead_pm",
  AssociatePm = "associate_pm",
  User = "user",
  Translator = "translator",
}

export { UserLanguageEnum, I18nEnum } from "@/shared/lib/i18n/i18n.types"

/** Values are the admin OTC list query parameter names. */
export enum CustomPlanSearchTypeEnum {
  Email = "email",
  ContractName = "contract_name",
}

export type CustomPlanFilter = {
  searchType: CustomPlanSearchTypeEnum
  searchValue: string
  state?: ContractStatusEnum
}

export type CardInfo = z.infer<typeof CardInfoSchema>
export type ContractInfo = z.infer<typeof ContractInfoSchema>
export type SubscriptionInfo = z.infer<typeof SubscriptionInfoSchema>
export type BillingInfo = z.infer<typeof BillingInfoSchema>
export type CustomPlanInfo = z.infer<typeof CustomPlanInfoSchema>
export type DecodedAccessToken = z.infer<typeof DecodedAccessTokenSchema>
export type GeolocationType = z.infer<typeof GeolocationSchema>
export type UserForm = z.infer<typeof UserFormSchema>
export type UserInfo = z.infer<typeof UserInfoSchema>
export type SignupReq = z.infer<typeof SignupReqSchema>
export type UserUsage = z.infer<typeof UserUsageSchema>

export type { TabItem, MultiDepthTab } from "@/shared/lib/navigation/navigation.types"
